module.exports = __webpack_public_path__ + "static/media/college-writing-i-completed.ad6040dc.svg";